// A régua de conversa de teste do servidor (`Conversation::DE_TESTE`, em app/models/conversation.rb), do
// lado da tela: é teste a conversa com a etiqueta `sandbox` ou a de um contato de teste. A etiqueta
// conta inteira, sem distinguir maiúscula e sem os espaços em volta; `sandbox-loja` não é teste.
// O contato entra porque o job que etiqueta as conversas dele roda depois, na fila, e o contato no
// store muda na hora (REPORTS-04 D29). A etiqueta chega, e sai, pelo `conversation.updated` do job.
const ETIQUETA_DE_TESTE = 'sandbox';

export const conversaDeTeste = (etiquetas = [], contato = {}) =>
  Boolean(contato.teste) ||
  etiquetas.some(
    etiqueta => etiqueta.trim().toLowerCase() === ETIQUETA_DE_TESTE
  );
